import React from 'react';
import { Instagram, ExternalLink, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export const InstagramFeed = () => {
  // Sample Instagram posts (in a real implementation, these would come from an API)
  const instagramPosts = [{
    id: 1,
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6hFDuMkKtrrN66CxmjRtGR/488225866_17848235589441316_3303414385176099418_n.jpg',
    caption: 'Glazen veranda project afgerond #veranova #veranda'
  }, {
    id: 2,
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/31qoFLD89xVNfcg4Xki5Xk/491436229_17850212535441316_3063343797506131228_n.jpg',
    caption: 'Lamellendak installatie #buitenleven #veranda'
  }, {
    id: 3,
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1kkTSutEG3n1jaMh5paBAH/487922126_17848235598441316_7489604228845729630_n.jpg',
    caption: 'Prachtige overkapping met LED verlichting #tuininspiratie'
  }, {
    id: 4,
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bbqzAX3HGa1qV4DnaGXJAq/IMG-20250423-WA0011.jpg',
    caption: 'Vrijstaande overkapping in moderne tuin #veranova'
  }];
  const instagramUrl = 'https://www.instagram.com/veranova_klussen?igsh=MTY5MmppcGx2ZmN2OQ==';
  return <section className="py-16 bg-gray-50" data-id="element-645">
      <div className="container mx-auto px-6" data-id="element-646">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-10" data-id="element-647">
          <div data-id="element-648">
            <div className="inline-flex items-center gap-3 mb-4" data-id="element-649">
              <div className="w-8 h-[2px] bg-[#CDA735]" data-id="element-650"></div>
              <span className="text-sm font-medium text-[#B89429] uppercase tracking-wider flex items-center" data-id="element-651">
                <Instagram size={16} className="mr-2" data-id="element-652" />
                Instagram
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2" data-id="element-653">
              Volg ons voor inspiratie
            </h2>
            <p className="text-gray-600 max-w-2xl" data-id="element-654">
              Bekijk onze recente projecten en laat u inspireren voor uw eigen
              droomveranda
            </p>
          </div>
          <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className="mt-4 md:mt-0 inline-flex items-center bg-[#CDA735] hover:bg-[#B89429] text-white font-medium px-6 py-3 rounded-md shadow-md transition-all" data-id="element-655">
            <span data-id="element-656">Volg ons op Instagram</span>
            <ExternalLink size={16} className="ml-2" data-id="element-657" />
          </a>
        </div>
        {/* Instagram Feed Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-658">
          {instagramPosts.map(post => <a key={post.id} href={instagramUrl} target="_blank" rel="noopener noreferrer" className="group overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-all duration-300" data-id="element-659">
              <div className="relative overflow-hidden" data-id="element-660">
                <img src={post.imageUrl} alt={`Veranova Instagram post: ${post.caption}`} className="w-full aspect-square object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-661" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end" data-id="element-662">
                  <div className="p-4 w-full" data-id="element-663">
                    <p className="text-white text-sm line-clamp-2" data-id="element-664">
                      {post.caption}
                    </p>
                  </div>
                </div>
                <div className="absolute top-3 right-3 bg-white/90 rounded-full p-1.5 shadow-md" data-id="element-665">
                  <Instagram size={16} className="text-[#E1306C]" data-id="element-666" />
                </div>
              </div>
            </a>)}
        </div>
        {/* View More Link */}
        <div className="mt-8 text-center" data-id="element-667">
          <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#CDA735] hover:text-[#B89429] font-medium" data-id="element-668">
            <span data-id="element-669">Bekijk meer op Instagram</span>
            <ArrowRight size={16} className="ml-2" data-id="element-670" />
          </a>
        </div>
      </div>
    </section>;
};